var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.186,
    height: 20.186,
    viewBox: "0 0 20.186 20.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_cerca",
    "data-name": "icona cerca",
    transform: "translate(0.7 0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_140",
    "data-name": "Tracciato 140",
    d: "M20.941,12.72A8.22,8.22,0,1,1,12.72,4.5,8.22,8.22,0,0,1,20.941,12.72Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_141",
    "data-name": "Tracciato 141",
    d: "M29.445,29.445l-4.47-4.47",
    transform: "translate(-10.949 -10.949)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fd874aadace920393a575ae3e8c230a3.svg";
export { ForwardRef as ReactComponent };